<template>
  <div class="accordion-group">
    <slot></slot>
  </div>
</template>

<script setup>
import { provide, ref, onMounted, onUnmounted } from 'vue';

const states = ref(new Map());
provide('accordionGroupStates', states);

const updateItem = (key, value) => {
  const newSet = new Map(states.value);
  newSet.set(key, value);
  for (let [k, v] of newSet) {
    if (k !== key && value && v) {
      newSet.set(k, false);
    }
  }
  states.value = newSet;
}

provide('updateAccordionItem', updateItem);

const closeAll = (excludedKey) => {
  const newSet = new Map(states.value);
  for (let [k] of newSet) {
    if (k !== excludedKey) {
      newSet.set(k, false);
    }
  }
  states.value = newSet;
}

provide('closeAccordionGroup', closeAll);

onMounted(() => {
  window.addEventListener('resize', closeAll);
});

onUnmounted(() => {
  window.removeEventListener('resize', closeAll);
});

</script>
